import React from "react";
import "./PageTitle.scss"

const PageTitle = ({heading}) => {
  return <h1 className={"page-title"}>{heading}</h1>
}

export default PageTitle
